import {NgModule} from '@angular/core';
import {AcModule} from "./ac/ac.module";
import {CfModule} from "./cf/cf.module";
import {CsModule} from "./cs/cs.module";
import {FeatureMiscRoutingModule} from "./feature-misc.routing.module";

@NgModule({
    imports: [
        AcModule,
        CfModule,
        CsModule,
        FeatureMiscRoutingModule

    ],
    exports: [
        AcModule,
        CfModule,
        CsModule,

    ]
})
export class FeatureMiscModule {
}